"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_xfvq9gq2l() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Location.tsx";
  var hash = "bf6a064e413a805e00a4e3b62d43f754c5200fd2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Location.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 48
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "bf6a064e413a805e00a4e3b62d43f754c5200fd2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_xfvq9gq2l = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_xfvq9gq2l();
var Icon = (cov_xfvq9gq2l().s[0]++, {
  name: 'location',
  svg: "<path d=\"M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2.75C12.6904 2.75 13.25 3.30964 13.25 4V6.13039C15.5605 6.62004 17.38 8.43946 17.8696 10.75L20 10.75C20.6904 10.75 21.25 11.3096 21.25 12C21.25 12.6904 20.6904 13.25 20 13.25H17.8696C17.38 15.5605 15.5605 17.38 13.25 17.8696V20C13.25 20.6904 12.6904 21.25 12 21.25C11.3096 21.25 10.75 20.6904 10.75 20V17.8696C8.43946 17.38 6.62004 15.5605 6.13039 13.25H4C3.30964 13.25 2.75 12.6904 2.75 12C2.75 11.3096 3.30964 10.75 4 10.75L6.13039 10.75C6.62004 8.43946 8.43946 6.62004 10.75 6.13039V4C10.75 3.30964 11.3096 2.75 12 2.75ZM15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12Z\" fill=\"currentColor\"/>"
});
var _default = exports["default"] = Icon;